var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isForeign)?[_c('big-title',[_vm._v(" Abonar Fondos ")]),_c('pay-funds-national')]:[_c('big-title',[_vm._v(" Abonar "),_c('span',[_vm._v("fondos")]),_vm._v(". ")]),_c('pay-funds-foreign')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }